import ClassBanner from "./ClassBanner";

export default ClassBanner;
